import uuid from 'uuid/v4';

const findParentNode = (nodes, nodeId) => {
    const parentNodeId = nodes[nodeId].parentId;
    return (
        // fastest
        nodes[parentNodeId] ||
        // fallback to search layout
        Object.values(nodes).find(({ childNodes }) => childNodes.includes(nodeId))
    );
};

export const actions = {
    addNodeAsChild: (set, get) => (node, parent) => {
        // If node already exists we want the node to be linked, not to override the existing node
        const nodeExists = get().nodes[node.id];
        const parentExists = get().nodes[parent];
        const identifier = node.id || uuid();

        if (!nodeExists && parentExists) {
            set((state) => ({
                ...state,
                nodes: {
                    ...state.nodes,
                    [identifier]: node,
                    [parent]: {
                        ...state.nodes[parent],
                        childNodes: [...state.nodes[parent].childNodes, identifier],
                    },
                },
            }));
        }
    },
    addNodeAsSibling: (set, get) => (node, nodeSiblingId) => {
        const editorNodes = get().nodes;
        const nodeExists = editorNodes[node.id];
        const identifier = node.id || uuid();

        const parentNode = findParentNode(editorNodes, nodeSiblingId);

        if (!nodeExists && parentNode) {
            const newChildNodePosition = parentNode.childNodes.indexOf(nodeSiblingId) + 1;
            const newChildNodes = [...parentNode.childNodes];
            newChildNodes.splice(newChildNodePosition, 0, identifier);

            set((state) => ({
                ...state,
                nodes: {
                    ...state.nodes,
                    [identifier]: {
                        ...node,
                        id: identifier,
                    },
                    [parentNode.id]: {
                        ...parentNode,
                        childNodes: [...newChildNodes],
                    },
                },
            }));
        }
    },
    removeNodeFromParent: (set, get) => (nodeId) => {
        const editorNodes = get().nodes;
        const parentNode = findParentNode(editorNodes, nodeId);

        if (parentNode) {
            const newChildNodes = [...parentNode.childNodes].filter((childNodeId) => childNodeId !== nodeId);

            // eslint-disable-next-line no-unused-vars
            const { [nodeId]: removedNode, ...filteredEditorNodes } = editorNodes;

            set((state) => ({
                ...state,
                nodes: {
                    ...filteredEditorNodes,
                    [parentNode.id]: {
                        ...parentNode,
                        childNodes: [...newChildNodes],
                    },
                },
            }));
        }
    },
};
